import { render, staticRenderFns } from "./Seragam.vue?vue&type=template&id=2fb9bd36&scoped=true"
import script from "./Seragam.vue?vue&type=script&lang=js"
export * from "./Seragam.vue?vue&type=script&lang=js"
import style0 from "./Seragam.vue?vue&type=style&index=0&id=2fb9bd36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9bd36",
  null
  
)

export default component.exports